(function () {
  'use strict';

  /* @ngdoc object
   * @name subsistemes.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.permisos', [
      'ui.router'
    ]);
}());